var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UiCheckbox from 'ui/v1/controls/UiCheckbox.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import UiTextButton from 'ui/v1/controls/UiTextButton.vue';
var Filters = /** @class */ (function (_super) {
    __extends(Filters, _super);
    function Filters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationTypes = [
            {
                name: 'email_received',
                label: 'inbound_email',
                icon: 'talent-email',
                state: true,
            },
            {
                name: 'talent_comment',
                label: 'talent_comment',
                icon: 'message-bubble',
                state: true,
            },
            {
                name: 'new_talent',
                label: 'new_talent',
                icon: 'talent-new',
                state: true,
            },
            {
                name: 'talent_moved',
                label: 'talent_moved',
                icon: 'talent-moved',
                state: true,
            },
            {
                name: 'talents_moved',
                label: 'talents_moved',
                icon: 'talents-moved',
                state: true,
            },
        ];
        _this.readStatuses = [
            {
                label: 'read',
                state: true,
            },
            {
                label: 'unread',
                state: true,
            },
        ];
        return _this;
    }
    Object.defineProperty(Filters.prototype, "activeNotificationTypes", {
        get: function () {
            return this.notificationTypes
                .filter(function (notificationType) { return notificationType.state; })
                .map(function (notificationType) { return notificationType.name; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Filters.prototype, "activeReadStatuses", {
        get: function () {
            return this.readStatuses
                .filter(function (read) { return read.state; })
                .map(function (read) { return read.label; });
        },
        enumerable: false,
        configurable: true
    });
    Filters.prototype.mounted = function () {
        var _this = this;
        if (this.$router.currentRoute.query.type) {
            this.notificationTypes.map(function (notificationType) {
                notificationType.state = _this.$router.currentRoute.query.type.includes(notificationType.name);
            });
        }
        if (this.$router.currentRoute.query.read) {
            this.readStatuses.map(function (notificationType) {
                notificationType.state = _this.$router.currentRoute.query.read.includes(notificationType.label);
            });
        }
    };
    Filters.prototype.getNotificationType = function (label) {
        switch (label) {
            case 'new_talent':
                return this.$t('notifications.types.new_talent');
            case 'talent_moved':
                return this.$t('notifications.types.talent_moved');
            case 'talents_moved':
                return this.$t('notifications.types.talents_moved');
            case 'talent_comment':
                return this.$t('notifications.types.talent_comment');
            case 'inbound_email':
            default:
                return this.$t('notifications.types.inbound_email');
        }
    };
    Filters.prototype.getNotificationFilterReadLabel = function (label) {
        switch (label) {
            case 'read':
                return this.$t('notifications.filters.read.read');
            case 'unread':
            default:
                return this.$t('notifications.filters.read.unread');
        }
    };
    Filters.prototype.setStateForAllNotificationTypes = function (newState) {
        this.notificationTypes.map(function (notificationType) {
            notificationType.state = newState;
            return notificationType;
        });
    };
    Filters.prototype.setStateForAllReadStatauses = function (newState) {
        this.readStatuses.map(function (notificationType) {
            notificationType.state = newState;
            return notificationType;
        });
    };
    Filters.prototype.updateUrl = function (newLocation) {
        history.replaceState({
            id: this.$router.currentRoute.name,
        }, this.$router.currentRoute.name, newLocation);
    };
    Filters.prototype.setQueryParam = function (name, content) {
        if (content === '') {
            content = '-';
        }
        var newLocation = {
            query: this.$router.currentRoute.query,
        };
        newLocation.query[name] = content;
        this.updateUrl(this.$router.resolve(newLocation).href);
    };
    Filters.prototype.unsetQueryParam = function (name) {
        var newLocation = {
            query: this.$router.currentRoute.query,
        };
        delete newLocation.query[name];
        this.updateUrl(this.$router.resolve(newLocation).href);
    };
    Filters.prototype.notificationsTypeChanged = function () {
        this.filter();
        if (this.activeNotificationTypes.length === this.notificationTypes.length) {
            this.unsetQueryParam('type');
            return;
        }
        this.setQueryParam('type', this.activeNotificationTypes.join());
    };
    Filters.prototype.readStateChanged = function () {
        this.filter();
        if (this.activeReadStatuses.length === this.readStatuses.length) {
            this.unsetQueryParam('read');
            return;
        }
        this.setQueryParam('read', this.activeReadStatuses.join());
    };
    Filters.prototype.filter = function () {
        var _this = this;
        var filteredNotifications = this.notifications;
        if (this.activeNotificationTypes.length !== this.notificationTypes.length) {
            filteredNotifications = filteredNotifications
                .filter(function (notification) { return _this.activeNotificationTypes.includes(notification.event); });
        }
        if (this.activeReadStatuses.length !== this.readStatuses.length) {
            filteredNotifications = filteredNotifications
                .filter(function (notification) { return (notification.read && _this.activeReadStatuses.includes('read') || (!notification.read && _this.activeReadStatuses.includes('unread'))); });
        }
        this.$emit('filtered', filteredNotifications);
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], Filters.prototype, "notifications", void 0);
    __decorate([
        Watch('notificationTypes', { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Filters.prototype, "notificationsTypeChanged", null);
    __decorate([
        Watch('readStatuses', { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Filters.prototype, "readStateChanged", null);
    __decorate([
        Watch('notifications', { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Filters.prototype, "filter", null);
    Filters = __decorate([
        Component({
            components: {
                UiTextButton: UiTextButton,
                Icon: Icon,
                UiCheckbox: UiCheckbox,
            },
        })
    ], Filters);
    return Filters;
}(Vue));
export default Filters;
